export const ExperimentTitleNames = {
  ContextualPaywallMessaging: "Contextual Paywall Messaging",
  HigherPaywall: "Higher Paywall",
  HomeMid: "HomeMid",
  LTSHardPaywall: "LTS 70 Hard Paywall",
  PaywallMasking: "Paywall Masking",
  WidgetFetch: "Widget Fetch",
};
